<ds-badge size="medium" [variant]="badgeVariant">
    <vn-icon name="theme-rocket" slot="start" />
</ds-badge>
